// import { useEffect } from 'react';
// import { callApi } from '../utils/apiClient';
// import { API_ENDPOINTS } from '../config/api/apiCall';


// export default function useFetchCountryList(isLoaded, setState, handleMessage,setIsCountryLoaded) {
//     useEffect(() => {
//         if (!isLoaded) {
//             const para = {
//                 p_companyid: localStorage.getItem('companyid'),
//             };

//             callApi(API_ENDPOINTS.Location_GET_COUNTRY, 'POST', { 'Content-Type': 'application/json' }, para)
//                 .then(data => {
//                     if (Array.isArray(data) && data.length > 0) {
//                         setState(data);
//                         setIsCountryLoaded(true);
//                     } else {
//                         setState([]);
//                     }
//                 })
//                 .catch(error => {
//                     handleMessage('error', error.message, 'Error');
//                 });
//         }
//     }, [isLoaded, setState, handleMessage]);
// }




import { useState, useEffect } from "react";
import { loadCountryList } from "../services/locationService";

const useCountryList = (editID) => {

    const [country, setCountry] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedCountryID, setSelectedCountryID] = useState(null);
    const [isCountryDataLoaded, setIsCountryDataLoaded] = useState(false);

    // Fetch department data
    const fetchCountryList = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadCountryList(para);
            if (data && data.length > 0) {
                setCountry(data);
                const initialDepartment = data.find((dept) => dept.id === selectedID);

                if (initialDepartment) { // ✅ Corrected check
                    setSelectedCountry(initialDepartment);
                    setSelectedCountryID(initialDepartment.id);
                    setIsCountryDataLoaded(true);
                }

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isCountryDataLoaded && editID === 0) {
            const loadCountries = async () => {
                await fetchCountryList();
            };
            loadCountries();
        }
    }, [isCountryDataLoaded, editID]);   

    // Function to load department based on selected ID
    const loadCountryByID = async (selectedID) => {
        await fetchCountryList(selectedID);
    };

    return {
        country,
        selectedCountry,
        selectedCountryID,
        setSelectedCountry,
        setSelectedCountryID,
        loadCountryByID,
    };
};

export default useCountryList;

